export default __webpack_public_path__ + "static/media/id_card.abfbee06.svg";